import { BaseContainerModel } from '../../base-container.model';
import {bl_bi_report_hdr_RowClass, bl_bi_report_query_run_output_hdr_RowClass} from '../../../dbschema';

export class BiReportHdrModel extends BaseContainerModel {
  bl_bi_report_hdr: bl_bi_report_hdr_RowClass = new bl_bi_report_hdr_RowClass();
}

export class ReportContainerModel extends BaseContainerModel {
  bl_bi_report_query_run_output_hdr: bl_bi_report_query_run_output_hdr_RowClass = new bl_bi_report_query_run_output_hdr_RowClass();
  bl_bi_report_hdr: bl_bi_report_hdr_RowClass = new bl_bi_report_hdr_RowClass();
}
